import { animate, style, transition } from '@angular/animations';

export const fadeToIf = (to: number) => [
  transition(':enter', [style({ opacity: 0 }), animate('0.15s ease-out', style({ opacity: to }))]),
  transition(':leave', [style({ opacity: to }), animate('0.15s ease-out', style({ opacity: 0 }))]),
];
